export class ReportPartTaskAccumulationType {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
}
